import type { LineItem } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

// ────────────────────────────────────────────────────────────────────────────────

export const useLineItemPrice = (
  lineItem: Partial<Pick<LineItem, 'perItemCost' | 'quantity'>>,
) => {
  const { formatPrice, t } = useLocalizationContext();
  const { perItemCost, quantity = 0 } = lineItem;

  const formattedPrice = formatPrice(perItemCost ?? 0, 'USD');
  const shouldUsePricingPerItem = quantity > 1;

  return shouldUsePricingPerItem
    ? `${formattedPrice}/${t('pdp.modifications.each')}`
    : formattedPrice;
};
